angular.module('contactModule').component('contactCondo', {
	templateUrl: 'contactCondo/contactCondo.html',
	bindings: {
		page: '<',
		target: '<',
		user: '<',
		startingDate: '<',
		nbDays: '<',
		type: '<',
		multisteps: '<',
		steps: '<',
		trackCategory: '<',
		trackAction: '<',
		trackActionQuestion: '<',
		trackLabel: '<',
		formData: '<',
		tabindexOrder: '<',
		companyPhone: '<',
		photoPlaceholder: '<',
		errorMessages: '<',
		successMessage: '<',
		defaultMessage: '<',
		placeholderMessage: '<',
		messageLabel: '<',
		subTitle: '<',
		subTitleExtra: '<',
		subTitleNoUnits: '<',
		popupName: '<',
		items: '<', // used for collections
		address: '<',
		customTitle: '<',
		isMobile: '<',
		contactId: '<',
		contactButtonText: '<',
		mode: '<',
		buildingToken: '<',
		listingRpc: '<',
		skipRentQuestions: '<',
		position: '<',
		source: '<',
		onSubmitForm: '&',
		onSubmitStep1: '&',
		emptyMessage: '<',
		emptyBuyerRenter: '<'
	},
	controller: ['$timeout', '$window', 'PubSub', '$element', 'crResourcesService', function($timeout, $window, PubSub, $element, crResourcesService) {
		var ctrl = this;

		this.$onInit = () => {
			this.titleStep1 = "Book a Tour";
			this.titleStep2 = "Your Tour";

			this.titleStepNoUnits = 'No Units Available<br/> for Virtual or<br/> In-Person Tour';
			this.buildingMessage = ''; //'What you are looking for and what time you would like to view?';
			this.listingMessage = ''; //'What time you would like to view?';
			this.marketDealsMessage = ''; //'Please tell us what you are looking for!';
			this.entryPopupMessage = ''; //'Please tell us what you are looking for!';
			this.showCompanyPhone = true;
			this.manualSubmitted = false;
			this.buttonText = this.contactButtonText || 'Contact';
			this.contactTypeSelected = null;
			this.showAddAnyQuestionsOrMessage = true;
			this.showDisclaimer = false;

			if (typeof this.formData !== "undefined" && typeof this.formData.dates !== "undefined") {
				this.ngSelectedDate = this.formData.dates[0].dateFormatted;
			} else {
				this.ngSelectedDate = null;
			}

			this.checkboxesBedrooms = [
				{
					id: 10,
					value: false,
					label: 'Studios'
				},
				{
					id: 11,
					value: false,
					label: '1 Bed'
				},
				{
					id: 12,
					value: false,
					label: '2 Beds'
				},
				{
					id: 13,
					value: false,
					label: '3 Beds'
				},
				{
					id: 14,
					value: false,
					label: '4 Beds'
				},
				{
					id: 15,
					value: false,
					label: 'Other'
				}
			];

			if (this.target && this.target.name) {
				if (this.target.assigned_by === 'CSR' || this.target.assigned_by === 'LK') {
					this.showCompanyPhone = false;
				}
			}

			if (this.user.isBroker) {
				this.subTitle = '';
				this.showCompanyPhone = false;
			}

			this.showName = true;
			this.showEmail = true;
			this.showPhone = true;

			// if the user is assigned he cannot change his informations
			if (this.target && (this.target.assigned_by === 'CSR' || this.target.assigned_by === 'LK')) {
				this.showName = false;
				this.showEmail = false;
				this.showPhone = false;
			}

			this.user.interestedInOffMarketListings = null;

			this.showMessage = true;
			this.updateUserMessage();
		};

		this.$postLink = () => {
			if (this.type.indexOf('building') !== -1) {
				$timeout(() => {
					if (typeof this.user.buyerRenter !== 'undefined') {
						this.setBuyerRenter();
					}
				});
			}
		};

		this.isPopup = () => {
			return this.popupName ? true : false;
		};

		this.isBuildingContact = () => {
			return this.type.indexOf("building") !== -1;
		}

		this.goBookATour = () => {
			this.contactTypeSelected = "tour";
			this.setStep(this.steps.STEP1);
		};

		this.goAskAQuestion = () => {
			this.contactTypeSelected = "question";
			this.setStep(this.steps.MOREINFORMATION);
			this.user.interestedInOffMarketListings = null;
		};

		this.goCancel = () => {
			this.contactTypeSelected = null;
			this.user.interestedInOffMarketListings = null;
			this.setStep(this.steps.STEP1);
		};

		this.selectDate = (date) => {
			var ctrl = this;
			if (typeof date === "undefined") {
				date = this.formData.dates.find((d) => {
					return d.dateFormatted == ctrl.ngSelectedDate;
				});
			}
			this.formData.dates.forEach((d) =>{
				d.selected = false;
			});

			date.selected = true;
			this.user.selectedDate = date;
		};

		this.submit = () => {
			this.manualSubmitted = true;
			this.form.$submitted = true;

			if (this.form.$valid) {
				if (!!this.page && this.page == 'listing' && !!this.type  && this.type == 'listing-sale') {
					// do nothing
				} else {
					this.form.showMessage = this.showMessage;
					this.form.showBuyingRentingCheckboxes = this.showBuyingRentingCheckboxes();
					this.form.showBuyingRentingError = this.showBuyingRentingError(this.form);
				}
				// add selected listings to the user data
				if (this.type.indexOf('building') !== -1
					&& !this.user.buyerRenter.buyer && this.user.buyerRenter.renter
					&& this.checkboxesListings) {
					let selectedBedrooms = this.checkboxesBedrooms.filter(bed => {
						return bed.value;
					});
					let selectedListings = this.checkboxesListings.filter(listing => {
						return listing.value;
					});
					if (selectedListings && selectedListings.length > 0) {
						this.user.listings = selectedListings;
						if (selectedBedrooms && selectedBedrooms.length > 0) {
							this.user.bedrooms = selectedBedrooms;
						}
						this.onSubmitForm({form: this.form});
					}
				} else {
					this.onSubmitForm({form: this.form});
				}
			}
		};

		this.isDisplayAssignedAgent = () => {
			if (this.steps.current !== this.steps.MOREINFORMATION &&
				!this.user.isBroker &&
				this.target &&
				(this.target.assigned_by === 'CSR' || this.target.assigned_by === 'LK' ) &&
				this.type.indexOf('building') === -1
			) {
				return true;
			}
			return false;
		};

		this.nextStep = () => {
			// for building contact, if renting is selected, then redirect to the bedrooms step
			if (this.type.indexOf('building') !== -1
				&& !this.skipRentQuestions
				&& this.steps.current === this.steps.STEP1
				&& this.user.buyerRenter.renter
				&& !this.user.buyerRenter.buyer
			) {
				this.setStep(this.steps.STEPBEDS);
			} else {
				this.setStep(this.steps.STEP2);
			}
		};

		this.setStep = (step) => {
			this.manualSubmitted = true;
			this.showMessage = true;
			this.showPhone = this.target && (this.target.assigned_by === 'CSR' || this.target.assigned_by === 'LK') ? false : true;

			// for building contact, we won't go the second step if the buyer renter checkboxes are not selected
			if (this.type.indexOf('building') !== -1 && this.steps.current === this.steps.STEP1 && step === this.steps.STEP2) {
				this.emptyBuyerRenter = (!this.user.buyerRenter.buyer && !this.user.buyerRenter.renter);
				if (!this.user.buyerRenter.buyer && !this.user.buyerRenter.renter) {
					return;
				}
			}

			// send rpc to get the listings based on the bedrooms selected previously
			if (this.type.indexOf('building') !== -1
				&& this.steps.current === this.steps.STEPBEDS && step === this.steps.STEP2
			) {
				let bedrooms = [];
				this.checkboxesBedrooms.forEach(bed => {
					if (bed.value) {
						if (bed.id === 15) { // other is selected (trick for bed)
							bedrooms.push(bed.id);
							bedrooms.push(bed.id + 1);
						} else {
							bedrooms.push(bed.id);
						}
					}
				});

				let data = {
					token: this.buildingToken,
					'bed[]': bedrooms
				};
				crResourcesService.get(this.listingRpc, data).$promise.then((res) => {
					if (res && res.rentals && res.rentals.length > 0) {
						this.checkboxesListings = res.rentals;
						this.showMessage = false;
						this.setStepFinalize(step);
					} else {
						// no units
						// this.setStepFinalize(step);
						this.showMessage = false;
						this.showPhone = false;
						this.setStepFinalize(this.steps.STEPNOUNITS);
					}

				}).finally(() => {
					this.loading = false;
				});
			} else {
				this.setStepFinalize(step);
			}
		};

		this.setStepFinalize = (step) => {
			this.manualSubmitted = false;

			// edgecase: if it's a step 1 of multi step form and name or email are missing, don't submit, proceed to step 2 instead. CITY-1965, after discussing with Zaid
			if (this.multisteps === true && this.steps.current === this.steps.STEP1 && !(this.user.name && this.user.email)) {
				if (step !== this.steps.MOREINFORMATION) {
					crTrackerQueue.track({
						category: this.trackCategory,
						action: this.trackAction,
						label: this.trackLabel
					});
				}

				this.setStep_part2(step);
				return ;
			}

			// normal step change
			if (this.steps.current === this.steps.STEP1 && step === this.steps.STEP2) {
				this.onSubmitStep1({form: this.form, successCallback: () => {
					this.setStep_part2(step);
				}});
			} else {
				this.setStep_part2(step);
			}
		};

		this.setStep_part2 = (step) => {
			if (!this.isMobile && step === this.steps.MOREINFORMATION) {
				crTrackerQueue.track({
					category: this.trackCategory,
					action: this.trackActionQuestion,
					label: this.trackLabel
				});
			}
			this.steps.current = step;
			this.updateUserMessage();
		};

		this.getTitle = () => {
			let title = '';

			if (this.steps.current === this.steps.STEP1 && this.customTitle) {
				title = this.customTitle;
			} else {
				let selectedDate = this.getSelectedDate();
				let formattedDate = moment(selectedDate.dateFormatted).format('ddd MMM D');
				if (this.user.isBroker) {
					title = 'For More<br/> Information';
				} else if (this.steps.current === this.steps.STEP1) {
					title = this.titleStep1;
				} else if (this.steps.current === this.steps.STEP2) {
					title = `${this.titleStep2} <br/> for ${formattedDate}`;
				} else if (this.steps.current === this.steps.STEPBEDS) {
					title = `${this.titleStep2} <br/> for ${formattedDate}`;
				} else if (this.steps.current === this.steps.STEPNOUNITS) {
					title = `${this.titleStepNoUnits}`;
				} else if (this.steps.current === this.steps.MOREINFORMATION) {
					title = 'For More<br/> Information';
				}
			}
			return title;
		};

		this.getSubTitle = () => {
			let subTitle = "";

			if (this.steps.current === this.steps.STEP1 || this.steps.current === this.steps.STEPBEDS) {
				subTitle = this.subTitle;
			} else if (this.steps.current === this.steps.STEPNOUNITS) {
				subTitle = this.subTitleNoUnits;
			} else if (this.steps.current === this.steps.MOREINFORMATION) {
				subTitle = "Ask us anything!<br/> Please include your email and phone #<br/> and we'll be in touch ASAP.";
			} else {
				subTitle = "Ask us anything!<br/> Please include your email and phone #<br/> and we'll be in touch ASAP.";
			}

			return subTitle;
		};

		this.getSubTitleExtra = () => {
			if (this.steps.current === this.steps.STEP1) {
				return this.subTitleExtra;
			}

			return "";
		};

		this.getSelectedDate = () => {
			return this.formData.dates.find((d) => {
				return d.selected;
			});
		};

		this.setListings= () => {
			let valid = false;
			let selectedListings = this.checkboxesListings.filter(list => {
				return list.value;
			});
			if (selectedListings) {
				valid = true;
			} else {
				valid = false;
			}
			this.form.buy.$setValidity('listings', valid);
		};

		this.hideBuyingRenting = () => {
			if (this.items && Object.entries(this.items).length > 0) {
				return this.items[Object.keys(this.items)[0]][0].listing_id ? true : false; // items are listings or buildings
			}
			return false;
		};

		this.showBuyingRentingCheckboxes = () => {
			let fl = !this.hideBuyingRenting()
				&& (this.steps.current === this.steps.STEP1 || this.mode === 'basic-question')
				&& (this.type.indexOf('building') !== -1 || (this.position === 'topnav' && this.source !== 'listing' ));
			return fl;
		};

		this.showBuyingRentingError = (form) => {
			let fl = (!this.multisteps && !!form.buy && form.buy.$invalid && form.$submitted)
				|| (this.multisteps && this.manualSubmitted && !!this.user && !!this.user.buyerRenter && !this.user.buyerRenter.buyer && !this.user.buyerRenter.renter);
			return fl;
		};

		this.updateUserMessage = () => {
			this.messageLabel = this.messageLabel || 'Please tell us what you are looking for';
			this.user.message = this.defaultMessage || "";

			if (this.steps.current === this.steps.MOREINFORMATION) {
				if (this.mode === 'basic-question') { // off market deals
					if (this.address) {
						if (this.popupName === 'popup-in-entry') {
							this.user.message = this.entryPopupMessage;
						} else {
							this.user.message = ""; //`I am interested in off-market deals at ${this.address}`;
							this.placeholderMessage = this.defaultMessage || "";
						}
					} else {
						this.user.message = this.defaultMessage || this.marketDealsMessage;
					}
				} else {
					this.user.message = this.defaultMessage;
				}

				this.messageLabel = "Message";
			} else {
				if (this.type.indexOf('building') !== -1) {
					//this.user.message = this.buildingMessage;
					this.user.message = "";
					this.messageLabel = "Please tell us what you are looking for";
				} else {
					this.user.message = "Also add any questions or message";
					this.messageLabel = "What time would you like to view?";
				}
			}
		};

		this.setBuyerRenter = () => {
			let valid = true;
			if (typeof this.form !== "undefined" && this.form.buy) {
				this.form.buy.$setValidity("buyerRenter", valid);
			}
		};
	}]
});